export namespace HomeStates {
    export function homeStatesFactory() {
        const homeStates: any = {
            stateA: {
                value: {},
                timestamp: new Date()
            },
            stateB: {
                value: false,
                timestamp: new Date()
            },
            homeBgBlur: false,
        };
        return homeStates;
    }

    export function mutations() {
        return {
            setHomeStateA(state: any, data: any) {
                state.home.stateA.value = data;
                state.home.stateA.timestamp = new Date();
            },
            bgBlurToggleHome(state: any, data: any) {
                state.home.homeBgBlur = !state.home.homeBgBlur;
            }
        };
    }
}
